import { MegamenuItem, NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";
import __megamenu from "./jsons/__megamenu.json";

const megaMenuDemo: MegamenuItem[] = [
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Company",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.Company,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "App Name",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.AppName,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/5059013/pexels-photo-5059013.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "City",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.City,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/5159141/pexels-photo-5159141.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Contruction",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.Contruction,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/7473041/pexels-photo-7473041.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Country",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.Country,
    })),
  },
];

const demoChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Online Booking",
  },
  {
    id: ncNanoId(),
    href: "/home-2",
    name: "Real Estate",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/home-3",
    name: "Home - 3",
    isNew: true,
  },
];

const otherPageChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/blog",
    name: "Blog Page",
  },
  {
    id: ncNanoId(),
    href: "/blog-single",
    name: "Blog Single",
  },
  {
    id: ncNanoId(),
    href: "/about",
    name: "About",
  },
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Contact us",
  },
  {
    id: ncNanoId(),
    href: "/login",
    name: "Login",
  },
  {
    id: ncNanoId(),
    href: "/signup",
    name: "Signup",
  },
  {
    id: ncNanoId(),
    href: "/subscription",
    name: "Subscription",
  },
];

const templatesChildrenMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/add-listing-1",
    name: "Add Listings",
    type: "dropdown",
    children: [
      {
        id: ncNanoId(),
        href: "/add-listing-1",
        name: "Add Listings 1",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-2",
        name: "Add Listings 2",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-3",
        name: "Add Listings 3",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-4",
        name: "Add Listings 4",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-5",
        name: "Add Listings 5",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-6",
        name: "Add Listings 6",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-7",
        name: "Add Listings 7",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-8",
        name: "Add Listings 8",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-9",
        name: "Add Listings 9",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-10",
        name: "Add Listings 10",
      },
    ],
  },
  //
  { id: ncNanoId(), href: "/checkout", name: "Checkout" },
  { id: ncNanoId(), href: "/pay-done", name: "Pay done" },
  //
  { id: ncNanoId(), href: "/author", name: "Author Page" },
  { id: ncNanoId(), href: "/account", name: "Account Page" },
];

export const NAVIGATION_DEMO: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home",
    type: "none",
    // children: demoChildMenus,
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/vehicles",
    name: "Fleet",
    type: "none",
    // megaMenu: megaMenuDemo,
  },
  {
    id: ncNanoId(),
    href: "/about",
    name: "About Us",
    type: "none",
    // megaMenu: megaMenuDemo,
  },
  // {
  //   id: ncNanoId(),
  //   href: "/coming-soon",
  //   name: "Start Earning",
  //   type: "megaMenu",
  //   // megaMenu: megaMenuDemo,
  // },
  // {
  //   id: 'location',
  //   name: 'Location',
  //   type: 'dropdown',
  //   children: [
  //     {
  //       id: 'scottsdale-car-rental',
  //       name: 'Scottsdale Car Rental',
  //       href: '/scottsdale-car-rental',
  //     },
  //     {
  //       id: 'phoenix-car-rental',
  //       name: 'Phoenix Car Rental',
  //       href: '/phoenix-car-rental',
  //     },
  //     {
  //       id: 'anthem-car-rental',
  //       name: 'Anthem Car Rental',
  //       href: '/anthem-car-rental',
  //     },
  //     {
  //       id: 'tempe-car-rental',
  //       name: 'Tempe Car Rental',
  //       href: '/tempe-car-rental',
  //     },
  //     {
  //       id: 'glendale-car-rental',
  //       name: 'Glendale Car Rental',
  //       href: '/glendale-car-rental',
  //     },
  //     {
  //       id: 'peoria-car-rental',
  //       name: 'Peoria Car Rental',
  //       href: '/peoria-car-rental',
  //     },
  //     {
  //       id: 'chandler-car-rental',
  //       name: 'Chandler Car Rental',
  //       href: '/chandler-car-rental',
  //     },
  //     {
  //       id: 'mesa-car-rental',
  //       name: 'Mesa Car Rental',
  //       href: '/mesa-car-rental',
  //     },
  //     {
  //       id: 'gilbert-car-rental',
  //       name: 'Gilbert Car Rental',
  //       href: '/gilbert-car-rental',
  //     },
  //     {
  //       id: 'surprise-car-rental',
  //       name: 'Surprise Car Rental',
  //       href: '/surprise-car-rental',
  //     },
  //     {
  //       id: 'goodyear-car-rental',
  //       name: 'Goodyear Car Rental',
  //       href: '/goodyear-car-rental',
  //     },

  //   ],
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/requirements",
  //   name: "Requirements",
  //   type: "none",
  //   // megaMenu: megaMenuDemo,
  // },
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Contact",
    type: "none",
    // megaMenu: megaMenuDemo,
  },
  {
    id: ncNanoId(),
    href: "/privacy-policy",
    name: "Privacy Policy",
    type: "none",
    // megaMenu: megaMenuDemo,
  },
  {
    id: ncNanoId(),
    href: "/terms-and-conditions",
    name: "Terms and Conditions",
    type: "none",
    // megaMenu: megaMenuDemo,
  },
  // {
  //   id: ncNanoId(),
  //   href: "/start-earning",
  //   name: "Start Earning",
  //   type: "none",
  //   // megaMenu: megaMenuDemo,
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/lease",
  //   name: "Lease",
  //   type: "none",
  //   // megaMenu: megaMenuDemo,
  // },
];
